<div>
  <i class="xos-icon" [ngClass]="!!title ? 'icon-' + title : 'icon-success'"></i>
  {{ message }}
</div>
<button (click)="close()">
  <i class="xos-icon icon-close-white"></i>
</button>
